import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { AppState } from '../../../store';
import { isAuthenticated } from '../../../store/actions/authActions';
import { AuthReducerState } from '../../../store/reducers/authReducer';
import { ROUTES } from '../../routes';
import { isAuthenticatedFromGDP } from '../../../store/actions/authActions';

type PrivateRouteProps = {
  component: any;
  exact: boolean;
  path: string;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { tokenData, gdpTokenData }: AuthReducerState = useSelector(
    (state: AppState) => state.authReducer,
  );

  return (
    <Route
      {...rest}
      render={props =>
        tokenData ||
        gdpTokenData ||
        isAuthenticated() ||
        isAuthenticatedFromGDP() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: ROUTES.AUTHENTICATION.path,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
